import Feature from 'ol/Feature';
import { Polygon } from 'ol/geom';
import { toPanelMapModuleFeatureId, toPanelMapStringFeatureId } from './panelMapFeatureId.js';
import {
  arrayFromApi,
  moduleFromApi,
  stringFromApi
} from './panelHierarchyMappers.js';
import {
  buildModuleMapFeatureProps,
  buildStringMapFeatureProps
} from './panelMapFeatureProps.js';

/**
 * String Feature 어댑터 — Domain 경유로 String 피처 생성
 */
export function drawStringFeature(vectorSource, stringInfo, arrayInfo, sectionInfo) {
  const stringDomain = stringFromApi(stringInfo);
  const ring = extractFirstRing(stringDomain.shapeGeog ?? stringInfo?.shapeGeog);
  if (!ring) {
    console.warn(
      `⚠️ drawStringFeature SKIP: displayNo=${stringDomain.displayNo} name="${stringDomain.name}" — shapeGeog 없음`
    );
    return null;
  }

  try {
    const arrayDomain = arrayFromApi(arrayInfo ?? {});
    const feat = makePolygonFeature(ring, {
      name: `String ${stringDomain.displayNo ?? stringDomain.seq ?? ''}`,
      id: toPanelMapStringFeatureId(stringDomain.seq),
      ...buildStringMapFeatureProps(stringDomain, {
        sectionSeq: sectionInfo?.id ?? stringInfo?.sectionIndex,
        arraySeq: arrayDomain.seq ?? arrayInfo?.id ?? stringInfo?.arrayIndex,
        arrayDisplayNo: arrayDomain.displayNo
      })
    });
    vectorSource.addFeature(feat);
    return feat;
  } catch (error) {
    console.error('❌ String feature 생성 실패:', stringDomain.displayNo, error);
    return null;
  }
}

/**
 * Module Feature 어댑터 — Domain 경유로 Module 피처 생성
 */
export function drawModuleFeature(vectorSource, moduleInfo, stringInfo, sectionInfo, arrayInfo) {
  const moduleDomain = moduleFromApi(moduleInfo);
  const stringDomain = stringFromApi(stringInfo ?? {});
  const ring = extractFirstRing(moduleDomain.shapeGeog ?? moduleInfo?.shapeGeog);
  if (!ring) return null;

  try {
    const arrayDomain = arrayFromApi(arrayInfo ?? {});
    const feat = makePolygonFeature(ring, {
      name: `Module ${moduleDomain.displayNo ?? ''}`,
      id: toPanelMapModuleFeatureId(moduleDomain.seq),
      ...buildModuleMapFeatureProps(moduleDomain, stringDomain, {
        sectionSeq: sectionInfo?.id ?? stringInfo?.sectionIndex,
        arraySeq: arrayDomain.seq ?? arrayInfo?.id ?? stringInfo?.arrayIndex,
        arrayDisplayNo: arrayDomain.displayNo
      })
    });
    vectorSource.addFeature(feat);
    return feat;
  } catch (error) {
    console.error('❌ Module feature 생성 실패:', moduleDomain.displayNo, error);
    return null;
  }
}

/** shapeGeog.coordinates → 단일 링 (GeoJSON·GeoLatte 중첩 모두) */
function extractFirstRing(shapeGeog) {
  const coords = shapeGeog?.coordinates;
  if (!coords?.length) return null;
  const first = coords[0];
  if (Array.isArray(first) && typeof first[0] === 'number') {
    return first.length >= 3 ? first : null;
  }
  if (Array.isArray(first) && Array.isArray(first[0])) {
    return first.length >= 3 ? first : null;
  }
  return null;
}

/** 링으로 OL Polygon Feature 생성 (첫 점과 마지막 점이 다르면 닫음) */
function makePolygonFeature(ring, props) {
  const closed =
    ring[0][0] !== ring[ring.length - 1][0] || ring[0][1] !== ring[ring.length - 1][1]
      ? [...ring, ring[0]]
      : ring;
  const feature = new Feature({
    geometry: new Polygon([closed]),
    ...props
  });
  if (props.id != null) {
    feature.setId(props.id);
  }
  return feature;
}
